import { motion } from 'motion/react';
import type { ReactNode } from 'react';

import { duration, easing, revealViewport } from './tokens';

/**
 * Fades and lifts its children into view once, on scroll. Under reduced-motion
 * (via MotionProvider) the lift is dropped and only the fade remains.
 */
export function Reveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  /** Seconds to wait before animating in — used to sequence sibling reveals. */
  delay?: number;
  className?: string;
}): JSX.Element {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={revealViewport}
      transition={{ duration: duration.section, ease: easing.entrance, delay }}
    >
      {children}
    </motion.div>
  );
}
